/*eslint-disable */
import { createStore } from "vuex";
import VuexPersistence from 'vuex-persist'
import global from "@/store/global";
import modules from './modules.js';

const vuexLocal = new VuexPersistence({
	key: process.env.VUE_APP_VUEX_NAME,
	storage: window.sessionStorage
})

export default createStore({
	...global,
	modules,
	plugins: [vuexLocal.plugin],
});
